import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import {
    StyledEngineProvider,
    ThemeProvider,
} from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import './index.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { App } from './app/App'
import { muiTheme } from './utils/theme'
import { initSentry } from './services/sentryLogger'

console.log('ENV =', process.env.NODE_ENV)
initSentry()

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement!)
// FIXME - not present in the default muiTheme 
muiTheme.components = {
    MuiPopover: {
        defaultProps: {
            container: rootElement,
        },
    },
    MuiPopper: {
        defaultProps: {
            container: rootElement,
        },
    },
}

root.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </StyledEngineProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
// serviceWorkerRegistration.register();